module.exports = __webpack_public_path__ + "static/screen_3-2bda77fe346c253c8824b75458682589.svg";